import { render, staticRenderFns } from "./TamanioUpdate.vue?vue&type=template&id=f346bba0&scoped=true&"
import script from "./TamanioUpdate.vue?vue&type=script&lang=js&"
export * from "./TamanioUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f346bba0",
  null
  
)

export default component.exports